import React, {MouseEvent, useMemo} from 'react';
import {FuPaUser} from '../../auth/authTypes';
import {styled} from '@mui/material/styles';
import {Image, ImageSrc, COLORS} from '@fupa/fupa-uikit';
import * as Sentry from '@sentry/react';

const Container = styled('div')`
  box-sizing: border-box;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  cursor: pointer;
  border: 1px solid white;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background-color: ${COLORS.lightGrey};
`;

interface AvatarProps {
  fupaUser: FuPaUser;
  onClick: (e: MouseEvent<HTMLDivElement>) => void;
}

const Avatar = ({fupaUser, onClick}: AvatarProps) => {
  const imageSrc = useMemo((): ImageSrc | null => {
    try {
      if (fupaUser.picture) {
        const pathArray = fupaUser.picture.split('/');
        pathArray.pop();
        const path = pathArray.join('/');
        return {
          path: path + '/',
          description: `Profilbild von ${fupaUser.name}`,
          source: null,
          svg: false,
        };
      } else {
        throw new Error('Firebase user has no picture');
      }
    } catch (e) {
      Sentry.setUser({id: fupaUser.user_id});
      Sentry.captureException(e);
      return null;
    }
  }, [fupaUser.picture, fupaUser.name, fupaUser.user_id]);

  return (
    <Container onClick={onClick}>
      {imageSrc && (
        <Image
          entity='user'
          height={40}
          width={40}
          src={imageSrc}
          alt={`Profilbild von ${fupaUser.name}`}
          ratio={'1:1'}
        />
      )}
    </Container>
  );
};

export default Avatar;
